<template>
  <div>
    <!-- pc -->
    <div class="table_6">
      <div class="title">
        <span>{{ itemType }}</span>
        <a :href="BSLink" v-html="itemTitle" target="_blank"></a>
      </div>
      <div class="table">
        <div class="row">
          <div class="block fl">
            <div class="sign fl">信息类别：</div>
            <div
              class="contentShort fl"
              v-html="zaiXianBanLi"
            >
              
            </div>
            <!-- <div
              class="contentShort fl"
              style="color: rgb(137, 137, 137)"
            >
              <a v-html="zaiXianBanLi" target="_blank"></a>
              
            </div> -->
          </div>
          <div class="block fl" style="border-right: none">
            <div class="sign fl">所属区域：</div>
            <div class="contentShort fl">
              
              <div class="contentShort fl" v-html="zaixianzixun"></div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row" style="border: none; min-height: 40px">
          <div class="block fl" style="border: none">
            <div class="sign fl" :style="{ height: ObjHeight }">开标时间：</div>
            <div class="contentShort fl" v-html="serviceObject">
              
            </div>
          </div>
          <div
            class="block fl"
            style="
              border-right: none;
              border-left: 1px solid rgb(204, 204, 204);
            "
          >
            <div class="sign fl" :style="{ height: ObjHeight }">开标地点:</div>
            <div
              ref="objContent"
              class="FWDX fl"
              v-html="orgName"
              style="background-color: #ffffff"
            >
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row" style="border-top: 1px solid rgb(204, 204, 204)">
          <div class="block fl">
            <div class="sign fl">项目编号：</div>
            <div
              class="contentShort fl"
              v-html="consultName"
              style="max-width: 260px"
            >
            </div>
          </div>
          <div class="block fl" style="border-right: none">
            <div class="sign fl">标包编号:</div>
            

            <div class="contentShort fl" v-html="consultValue">
              
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row">
          <div class="block fl">
            <div class="sign fl">标段数量：</div>
            <div class="contentShort fl" v-html="belongCity">
              
            </div>
          </div>
          <div class="block fl" style="border-right: none">
            <div class="sign fl">交易中心名称:</div>
            <div class="contentShort fl" v-html="exerciseLevel">
              
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row" style="border:none;">
          <div class="block fl" style="border-right: none; width: 823px">
            <div class="sign fl">项目名称：</div>
            <div class="content fl" v-html="approvalresultsName">
              
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <!-- <div class="row">
          <div class="block fl" style="border-right: none; width: 823px">
            <div class="sign fl">办理地点:</div>
            <div class="content fl" v-html="serviceAddr">
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row" style="border-bottom: none">
          <div class="block fl" style="border-right: none; width: 823px">
            <div
              class="sign fl"
              style="width: 70px; padding-right: 20px; text-align-last: justify"
            >
              摘 要:
            </div>
            <div class="content fl" v-html="itemAbstract">
            </div>
          </div>
        </div>
        <div class="clear"></div> -->
      </div>
      <!-- <div class="info">
        <div class="department fl">
          <a :href="BSLink" v-html="BuMen">
          </a>
        </div>
        <div class="date fl">
          {{cDate.substring(0,10)}}
        </div>
      </div> -->
    </div>
    <!-- mobile -->
    <div class="mobile">
      <div class="title">
        <!-- <span v-html="itemType">
          
        </span> -->
        <a :href="BSLink" v-html="itemTitle" target="_blank">
          
        </a>
      </div>
      <div class="table">
        <tr>
          <td>信息类别</td>
          <td v-html="zaiXianBanLi"></td>
        </tr>

        <tr>
          <td>所属区域</td>
          <td>
            <a v-html="zaixianzixun" target="_blank">
              
            </a>
          </td>
        </tr>

        <tr>
          <td>开标时间</td>
          <td v-html="itemType"></td>
        </tr>

        <tr>
          <td>开标地点</td>
          <td v-html="serviceObject"></td>
        </tr>

        <tr>
          <td>项目编号</td>
          <td v-html="orgName"></td>
        </tr>

        <tr>
          <td>标包编号</td>
          
          <td v-html="consultValue"></td>
        </tr>

        <tr>
          <td>标段数量</td>
          <td v-html="belongCity"></td>
        </tr>

        <tr>
          <td>交易中心名称</td>
          <td v-html="exerciseLevel"></td>
        </tr>

        <tr>
          <td>项目名称</td>
          <td v-html="approvalresultsName" class="zhaiyao"></td>
        </tr>

        <!-- <tr>
          <td>办理地点</td>
          <td v-html="serviceAddr" class="zhaiyao"></td>
        </tr>

        <tr>
          <td>摘要</td>
          <td v-html="itemAbstract" class="zhaiyao"></td>
        </tr> -->
      </div>
      <!-- <div class="info">
        <div class="department fl" style="margin-right: 5px">
          <a :href="BSLink" v-html="BuMen" target="_blank">
            
          </a>
        </div>
        <div class="date fl">
          {{cDate.substring(0,10)}}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "v-table-work",
  components: {},
  props: {
    cWorkData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      ObjHeight: "",
    };
  },
  watch: {},
  computed: {
    // 类型 事项类型
    itemType() {
      // return this.cWorkData.itemType;
      return "交易信息";
    },
    // 标题
    itemTitle() {
      return this.cWorkData.notice_name;
    },
    // 在线办理
    zaiXianBanLi() {
      return this.cWorkData.transaction_type_name;
    },
    // // 在线咨询
    zaixianzixun() {
      return this.cWorkData.platform_name;
    },
    // 服务对象
    serviceObject() {
      return this.cWorkData.bid_opening_time;
    },
    // // 实施主体
    orgName() {
      return this.cWorkData.bid_opening_address;
    },
    // //咨询电话
    consultName() {
      return this.cWorkData.project_code;
    },
    // // 咨询电话号
    consultValue() {
      return this.cWorkData.bid_section_codes;
    },
    // // 所属盟市
    belongCity() {
      return this.cWorkData.notice_bid_num;
    },
    // // 行使层级
    exerciseLevel() {
      return this.cWorkData.data_source_name;
    },
    // // 审批结果
    approvalresultsName() {
      return this.cWorkData.project_name;
    },
    // // 办理地点
    // serviceAddr() {
    //   return this.cWorkData.notice_type_name;
    // },
    // // 摘要
    // itemAbstract() {
    //   return this.cWorkData.notice_content;
    // },
    // // 部门
    // BuMen() {
    //   return "内蒙古自治区公共资源交易中心&nbsp";
    // },
    // // 日期
    // // 暂无数据
    // cDate() {
    //   return this.cWorkData.docpubtime;
    // },
    // handleForm() {
    //   return this.cWorkData.handleForm;
    // },
    // // 办事链接
    BSLink() {
      return (
        "http://trs.nmsuny.com:6689/ggzyjyw/jyxx/index_468.html?id=" +
        this.cWorkData.source_data_key 
      );
    },
    // // 咨询链接
    // ZXLink() {
    //   return (
    //     "http://zwfw.nmg.gov.cn/consulation?itemId=" +
    //     this.cWorkData.docNo +
    //     "&regionCode=" +
    //     this.cWorkData.regionCode
    //   );
    // },
  },
  methods: {
    height() {
      this.ObjHeight = window.getComputedStyle(this.$refs.objContent).height;
    },
  },
  created() {},
  mounted() {
    this.height();
    // console.log(this.ObjHeight);
  },
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}
a {
  text-decoration: none;
  color: rgb(1, 82, 147);
  // margin-left: 5px;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .table_6 {
    display: block;
    width: 823px;
    // min-height: 340px;
    margin-bottom: 40px;
    .title {
      width: 823px;
      height: 30px;
      margin-bottom: 20px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      font-size: 18px;
      span {
        height: 20px;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4px 10px 4px 10px;
        margin-right: 5px;
      }
    }
    .table {
      width: 823px;
      min-height: 205px;
      border: 1px solid rgb(204, 204, 204);
      .row {
        min-height: 40px;
        height: 40px;
        width: 823px;
        border-bottom: 1px solid rgb(204, 204, 204);
        .block {
          min-height: 40px;
          width: 400px;
          border-right: 1px solid rgb(204, 204, 204);
          font-size: 16px;
          line-height: 40px;

          .sign {
            width: 110px;
            height: 40px;
            // text-align-last: justify;
            padding-left: 10px;
            font-weight: bold;
            background-color: rgb(250, 250, 250);
          }
          .content {
            height: 40px;
            max-width: 700px;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          .contentShort {
            height: 40px;
            max-width: 280px;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            a {
              color: #d51524;
              text-decoration: underline;
            }
          }
          .FWDX {
            min-height: 40px;
            width: 260px;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
    .info {
      height: 20px;

      margin-top: 10px;
      color: rgb(169, 169, 169);

      .department {
        a {
          color: rgb(169, 169, 169);
        }
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  @w: 7.5vw;

  .table_6 {
    display: none;
  }
  .mobile {
    display: block;
    width: 730 / @w;

    // height: 410 / @w;
    padding-left: 20 / @w;
    padding-bottom: 60 / @w;
    border-bottom: 15 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;

    .title {
      width: 700 / @w;
      height: 50 / @w;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      margin-bottom: 10 / @w;
      // font-size: 16 / @w;
      line-height: 45 / @w;
      font-size: 18px;
      font-weight: bold;
      span {
        height: 20 / @w;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4 / @w 10 / @w 4 / @w 10 / @w;
      }
      a {
        white-space: nowrap;
      }
    }
    .table {
      width: 700 / @w;
      // height: 145px;
      border: 1 / @w solid rgb(204, 204, 204);
      border-bottom: none;
      a {
        color: #d51524;
        text-decoration: underline;
      }
      tr {
        width: 700 / @w;
        height: 40 / @w;
        line-height: 40 / @w;

        td {
          width: 530 / @w;
          border-bottom: 1 / @w solid rgb(204, 204, 204);
          padding-left: 15 / @w;
          padding-right: 15 / @w;
        }
        td:first-child {
          background-color: rgb(250, 250, 250);
          border-right: 1 / @w solid rgb(204, 204, 204);
          // border-top: 1 / @w solid rgb(204, 204, 204);
          width: 120 / @w;
          max-height: 120 / @w;
          text-align-last: justify;
          padding-left: 10 / @w;
          padding-right: 10 / @w;
        }

        .zhaiyao {
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
    }
    .info {
      margin-top: 10 / @w;
      a {
        color: rgb(169, 169, 169);
      }
      color: rgb(169, 169, 169);
    }
  }
}
</style>